import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=764c4c6d&scoped=true&"
import script from "./Slider.vue?vue&type=script&lang=js&"
export * from "./Slider.vue?vue&type=script&lang=js&"
import style0 from "./Slider.vue?vue&type=style&index=0&id=764c4c6d&prod&lang=scss&"
import style1 from "./Slider.vue?vue&type=style&index=1&id=764c4c6d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764c4c6d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
